/**
 * Guía: Versiones de la App.
 *
 * Contenido derivado del capítulo **05** del manual —§0 (la palanca de más
 * alcance del panel), §3 (qué declara cada fila), §5 (unicidad y monotonía)—
 * y del flujo F41, que es lo que se le responde a quien pregunta.
 *
 * El aviso del §2 es el paso central: marcar obligatoria una versión que
 * todavía no está publicada en su tienda deja a ese sistema entero sin app y
 * sin forma de actualizar.
 */

import type { TourFlow } from '../types';

const VERSIONES_PATH = '/app-versions';

export const c05VersionesDeLaApp: TourFlow = {
  id: 'admin.app-versions',
  chapter: '05',
  title: 'Versiones de la app',
  summary:
    'La palanca de más alcance: qué bloquea una versión obligatoria y cuándo no se debe activar.',
  href: VERSIONES_PATH,
  estimatedMin: 3,
  steps: [
    {
      id: 'intro',
      title: 'La pantalla con más alcance del panel',
      body:
        'Marcar una versión como obligatoria y activarla deja fuera de servicio, en ' +
        'minutos, a todo el parque de teléfonos que esté por debajo. Conviene entenderla ' +
        'antes de tocarla.',
      route: VERSIONES_PATH,
    },
    {
      id: 'two-switches',
      title: 'Hacen falta las dos casillas',
      body:
        'Obligatoria y activa. Una versión obligatoria pero inactiva no bloquea a nadie: es ' +
        'la combinación la que corta, y por eso se puede preparar sin efecto y encender ' +
        'después.',
      target: 'admin.appVersions.list',
      placement: 'top',
      optionalTarget: true,
    },
    {
      id: 'ios-android-separate',
      title: 'iOS y Android van por separado',
      body:
        'Cada sistema lleva su propia secuencia porque las tiendas revisan y publican por su ' +
        'cuenta. **Antes de marcar obligatoria una versión, tiene que estar publicada en esa ' +
        'tienda**: si no, dejas a ese sistema entero bloqueado y sin forma de actualizar.',
    },
    {
      id: 'only-forward',
      title: 'Las versiones sólo avanzan',
      body:
        'No se registra una menor que la más alta ya registrada de ese sistema, ni se ' +
        'repite una existente — y da igual que la mayor esté desactivada. El número de una ' +
        'versión ya registrada tampoco se edita: es su identidad.',
    },
    {
      id: 'when-it-lands',
      title: 'El bloqueo llega cuando el teléfono pregunta',
      body:
        'En el servidor el cambio es inmediato; en cada teléfono, en su siguiente ' +
        'comprobación —al arrancar o al volver a primer plano, como mucho cada media hora—. ' +
        'Lo mismo al desactivarlo. Que alguien siga dentro un rato después no es un fallo.',
    },
    {
      id: 'fails-open',
      title: 'Si el servidor no responde, no se bloquea a nadie',
      body:
        'La app asume que está al día y deja pasar. Por eso una caída de la plataforma no ' +
        'produce una oleada de «me pide actualizar»: si aparece, es que alguien activó un ' +
        'bloqueo.',
    },
  ],
};
